import React from 'react';
import {
    AddressLocation,
    AddressLocationFontSize,
    AddressLocationIndicatorStyle,
    AddressLocationLine1Style,
} from '../AddressLocation';
import { DemoSection } from './common/SectionNavigator';
import { DemoExample, DemoPage, DemoPageSection } from './common/DemoLayout';

const sections: DemoSection[] = [
    { id: 'addressLocationDemo_propertyindicator', title: 'Property Indicator' },
    { id: 'addressLocationDemo_regularstyle', title: 'Regular Style' },
    { id: 'addressLocationDemo_boldstyle', title: 'Bold Style' },
    { id: 'addressLocationDemo_singleline', title: 'Single Line' },
];

/** The four indicator colours each style is shown in. */
const indicators: { name: string; style?: AddressLocationIndicatorStyle }[] = [
    { name: 'blue' },
    { name: 'black', style: AddressLocationIndicatorStyle.Black },
    { name: 'gray', style: AddressLocationIndicatorStyle.Gray },
    { name: 'red', style: AddressLocationIndicatorStyle.Red },
];

const indicatorLabel = (name: string) => (
    <>
        Address with no property indicator (<b>{name}</b> indicator):
    </>
);

export const AddressLocationDemo: React.FC = () => {
    return (
        <div style={{ maxWidth: '500px' }}>
            <DemoPage
                title='Address Location :'
                sections={sections}
            >
                <DemoPageSection
                    id={sections[0].id}
                    title='Property Indicator'
                >
                    <DemoExample label='Address with no property indicator:'>
                        <AddressLocation
                            addressLine1='33 Browning St'
                            addressLine2='Testville IN 34872'
                        />
                    </DemoExample>
                    <DemoExample label='Address with property indicator:'>
                        <AddressLocation
                            addressLine1='33 Browning St'
                            addressLine2='Testville IN 34872'
                            propertyNumber={3}
                        />
                    </DemoExample>
                </DemoPageSection>
                <DemoPageSection
                    id={sections[1].id}
                    title='Regular Style'
                >
                    {indicators.map(({ name, style }) => (
                        <DemoExample
                            key={name}
                            label={indicatorLabel(name)}
                        >
                            <AddressLocation
                                addressLine1='33 Browning St'
                                addressLine2='Testville IN 34872'
                                indicatorStyle={style}
                            />
                        </DemoExample>
                    ))}
                </DemoPageSection>
                <DemoPageSection
                    id={sections[2].id}
                    title='Bold Style'
                >
                    {indicators.map(({ name, style }) => (
                        <DemoExample
                            key={name}
                            label={indicatorLabel(name)}
                        >
                            <AddressLocation
                                addressLine1='33 Browning St'
                                addressLine2='Testville IN 34872'
                                indicatorStyle={style}
                                line1Style={AddressLocationLine1Style.Bold}
                            />
                        </DemoExample>
                    ))}
                </DemoPageSection>
                <DemoPageSection
                    id={sections[3].id}
                    title='Single Line (bold style / smaller fonts)'
                >
                    {indicators.map(({ name, style }) => (
                        <DemoExample
                            key={name}
                            label={indicatorLabel(name)}
                        >
                            <AddressLocation
                                addressLine1='33 Browning St, Testville IN 34872'
                                indicatorStyle={style}
                                line1Style={AddressLocationLine1Style.Bold}
                                fontSize={AddressLocationFontSize.Smaller}
                            />
                        </DemoExample>
                    ))}
                </DemoPageSection>
            </DemoPage>
        </div>
    );
};
